// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"d08eb7f0","254":"f9e3f467","651":"7c2f7453"}[chunkId] + ".chunk.js";
};